import React from 'react';
import postal from 'postal';
import { useAppDispatch } from '../app/hooks';
import { showGlobalOkDialog } from '../features/globalOkDialogSlice';
import { formatDialogContent } from './dialogHelpers';

/**
 * useGlobalOkDialog - provides generic function for displaying Ok dialog
 *
 * @export
 * @return {*} 
 */
export default function useGlobalOkDialog() {
  const dispatch = useAppDispatch();
  const channel = postal.channel('ajax');

  /**
   * showOkDialog - awaitable Promise to show global ok dialog
   *
   * @param {React.ReactNode}|string contentParam - content to render inside the dialog
   * @param {boolean} [hideOkButton=false] - set to true in case default Ok button needs to be hidden
   * @param {(string|null)} [top=null] - use to override top position on the screen (middle of the screen by default)
   * @return {*} 
   */
  function showOkDialog(contentParam:string|React.ReactNode, hideOkButton:boolean = false, top:string|null = null, type:'info'|'error'|'warning' = 'info' ) {
    channel.publish('ajax.loadingend', {});

    return new Promise<void>(resolve => {
      dispatch(showGlobalOkDialog({
        content: formatDialogContent(contentParam),
        hideOkButton,
        top,
        resolve,
        type,
      }));
    })
  }

  return [showOkDialog];
}